(() => {
  if (window.__YIZCHO_DROP_HOUSE_DEEPLINK_V01__) return;
  window.__YIZCHO_DROP_HOUSE_DEEPLINK_V01__ = true;

  const TARGET_HASH = "#drop-house";
  const houseId = () => window.YizchoRoomRoutes?.drop || "HOUSE-02";
  const TOUR_STORAGE_KEY = "yizcho:island-tour-v3";
  const MAX_WAIT_MS = 14000;
  const RETRY_MS = 120;
  let opening = false;
  let retryStartedAt = 0;
  let retryTimer = 0;

  const suppressIslandTour = () => {
    if (window.location.hash !== TARGET_HASH) return false;

    try {
      window.localStorage.setItem(TOUR_STORAGE_KEY, "skipped");
    } catch (error) {
      console.warn("Yizcho Drop House could not persist the tour preference", error);
    }

    const tourWasOpen = Boolean(document.body?.classList.contains("tour-open"));
    if (tourWasOpen) {
      document.querySelector("#island-tour-skip")?.click();
    }
    return tourWasOpen;
  };

  const waitFor = (predicate, timeout = 7000) => new Promise((resolve, reject) => {
    const startedAt = Date.now();
    const check = () => {
      if (predicate()) {
        resolve();
        return;
      }
      if (Date.now() - startedAt >= timeout) {
        reject(new Error("The Drop House took too long to open."));
        return;
      }
      window.setTimeout(check, RETRY_MS);
    };
    check();
  });

  const consumeHash = () => {
    if (window.location.hash !== TARGET_HASH) return;
    const cleanUrl = new URL(window.location.href);
    cleanUrl.hash = "";
    window.history.replaceState(
      window.history.state,
      "",
      `${cleanUrl.pathname}${cleanUrl.search}`,
    );
  };

  const clearRetry = () => {
    if (!retryTimer) return;
    window.clearTimeout(retryTimer);
    retryTimer = 0;
  };

  const scheduleRetry = () => {
    clearRetry();
    if (window.location.hash !== TARGET_HASH) return;
    if (!retryStartedAt) retryStartedAt = Date.now();
    if (Date.now() - retryStartedAt >= MAX_WAIT_MS) return;
    retryTimer = window.setTimeout(openFromHash, RETRY_MS);
  };

  async function openFromHash() {
    if (window.location.hash !== TARGET_HASH || opening) return false;
    if (suppressIslandTour()) {
      scheduleRetry();
      return false;
    }
    if (document.body.classList.contains("has-drop-house")) {
      consumeHash();
      if(matchMedia('(max-width:759px)').matches){await waitFor(()=>document.querySelector('#drop-house .yizcho-room-frame')?.contentDocument.querySelector('#room-return'));document.querySelector('#drop-house .yizcho-room-frame')?.contentDocument.querySelector('#room-return')?.focus({preventScroll:true});}else document.querySelector("#drop-house-close")?.focus({ preventScroll: true });
      return true;
    }

    const hotspot = document.querySelector(`.hotspot[data-id="${houseId()}"]`);
    const loading = document.querySelector(".loading");
    if (!hotspot || loading) {
      scheduleRetry();
      return false;
    }

    opening = true;
    clearRetry();
    try {
      hotspot.click();
      await waitFor(() => {
        const roomEntry = document.querySelector("#room-entry");
        return roomEntry && !roomEntry.hidden && !roomEntry.disabled;
      });
      document.querySelector("#room-entry")?.click();
      await waitFor(() => document.body.classList.contains("has-drop-house"));
      consumeHash();
      if(matchMedia('(max-width:759px)').matches){await waitFor(()=>document.querySelector('#drop-house .yizcho-room-frame')?.contentDocument.querySelector('#room-return'));document.querySelector('#drop-house .yizcho-room-frame')?.contentDocument.querySelector('#room-return')?.focus({preventScroll:true});}else document.querySelector("#drop-house-close")?.focus({ preventScroll: true });
      return true;
    } catch (error) {
      console.error("Yizcho Drop House deep link failed", error);
      return false;
    } finally {
      opening = false;
    }
  }

  const begin = () => {
    suppressIslandTour();
    retryStartedAt = Date.now();
    void openFromHash();
  };

  suppressIslandTour();
  window.addEventListener("hashchange", begin);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", begin, { once: true });
  } else {
    begin();
  }
})();
